import CheckProdCD from "./components/checkProdCD";

var $window = $(window);
var $body = $("body");
var $header = $("#header");
var $wrapper = $("#wrapper");
var spaceToHeaderFixed;
var language = $("html").attr("lang");
var timeTransitionDefault = 350;
var texts = [];
window.page = $body.data("page");

texts["pt-BR"] = {
  quantity: "quantidade",
  price: "preço",
  cart_empty: "O seu carrinho está vazio",
  go_product: "Ir para a página do produto",
  btn_edit_cart: "Editar pedido",
  btn_checkout: "Finalizar pedido",
  btn_success: "Adicionado!",
  errorsTxt: {
    withoutSku: "Selecione um atributo para o produto",
  },
};

texts["en"] = {
  quantity: "quantity",
  price: "price",
  cart_empty: "Cart is empty...",
  go_product: "Go to product page",
  btn_edit_cart: "Edit order",
  btn_checkout: "Finish order",
  btn_success: "Added!",
  errorsTxt: {
    withoutSku: "Select an attribute for the product",
  },
};

function getText(key, subKey) {
  if (typeof subKey == "undefined") {
    return texts[language][key];
  } else {
    return texts[language][key][subKey];
  }
}

window.store = {
  config: {
    // Seletor do botão de comprar
    selectorBtnBuy: '[data-action="add-cart"]',
    selectorBtnBuyAssinatura: '[data-action="add-cart-assinatura"]',
    // Seletor do elemento que engloba um produto
    selectorWrapperProduct: "[data-box-produto]",
    selectorWrapperProductAssinatura: "[data-box-produto-assinatura]",
    selectorFormProduct: "[data-form-product]",
    selectorFormProductAssinatura: "[data-form-product-assinatura]",
    // Se a store tem versão internacional ou não
    hasInternacionalVersion: false,
    errorsTxt: {
      withoutSku: getText("errorsTxt", "withoutSku"),
    },
    // configuração de comportamento ao add um produto
    addToCartOpenCartpopup: true,
    addToCartOpenCartpopupMobile: true,
    cartCount: {
      selector: "[data-cart-count]",
      attr: "[data-cart-count-attr]",
      text: "[data-cart-item-text]",
    },
    priceProds: {
      selector: "[data-update-price]",
      attr: "update-price",
    },
  },
  formatMoney: function (value) {
    // FORMATA UM VALOR
    return (
      "R$ " +
      value
        .toFixed(2)
        .replace(".", ",")
        .replace(/(\d)(?=(\d{3})+\,)/g, "$1.")
    );
  },
  validateQuantity: function (_val) {
    // VALIDA SE A QUANTIDADE INFORMADA É UM NÚMERO
    if (!isNaN(_val)) {
      if (parseInt(_val) > 0) {
        return true;
      }
    }

    return false;
  },
  getClearNumber: function (_val) {
    // RETORNA UM NÚMERO LIMPO COMO INT
    if (!isNaN(_val)) {
      clearNumber = parseInt(_val);

      return clearNumber;
    }

    return false;
  },
  validateFormProduct: function (_$form) {
    // VALIDA O FORM DE PRODUTO PARA VER SE O PRODUTO PODE SER ADICIONADO
    var $parent = _$form.closest("[data-box-produto]");
    var $btnComprar = _$form.find('[data-action="add-cart"]');
    var validated = true;
    var errorsTxt = [];

    console.log($btnComprar.data("available"));

    //  verifica se o sku foi selecionado
    if (_$form.find('[name="sku"]').val() == "") {
      validated = false;
      errorsTxt.push("Selecione um atributo para o produto");
    }

    //  verifica se a quantidade é válida
    console.log(_$form.find('input[name="quantity"]').val());
    if (_$form.find('input[name="quantity"]').val() <= 0) {
      console.log("qtd invalida");
      validated = false;
      errorsTxt.push("Quantidade indisponível");
    }

    return { validated: validated, errors: errorsTxt };
  },
  setRespValidateProduct: function (_resp, _$form, _$boxResponse) {
    // var $boxResult = _$form.find('.resp-validate');
    var $boxResult = _$boxResponse;
    var htmlErrors = "";

    if (_resp.validated) {
      $boxResult.empty();
    } else {
      for (var i = _resp.errors.length - 1; i >= 0; i--) {
        htmlErrors += '<span class="msg error">' + _resp.errors[i] + "</span>";
      }

      $boxResult.html(htmlErrors);
      setTimeout(function () {
        $boxResult.html("");
      }, 4000);
    }
  },
  addItemResultDefault: function (_$form, _typeResult, _result, _$boxResponse) {
    var _this = this;
    if (_typeResult == "produto-adicionado") {
      var $btnComprar = _$form.find(_this.config.selectorBtnBuy);

      $btnComprar.addClass("success").html("Produto adicionado!");

      setTimeout(function () {
        // _$form.find('.msg-response').slideUp(350);
        $btnComprar
          .removeClass("success")
          .html($btnComprar.data("text-available"));
      }, 3500);

      setTimeout(function () {
        window.location.href = urlCart;
      }, 150);
    } else if (_typeResult == "erro-adicionar") {
      var errorText = JSON.parse(_result.responseText);

      if (typeof _$boxResponse != "undefined" && _$boxResponse.length > 0) {
        console.info(errorText);

        _$boxResponse.addClass("error");
        _$boxResponse.removeClass("success");

        _$boxResponse.find("span").html(errorText.error);
        _$boxResponse.slideDown(350);

        setTimeout(function () {
          _$boxResponse.slideUp(350);
        }, 3500);
      }
    }
  },
  addItemResultDefaultAssinatura: function (
    _$form,
    _typeResult,
    _result,
    _$boxResponse
  ) {
    var _this = this;
    if (_typeResult == "produto-adicionado") {
      var $btnComprar = _$form.find(_this.config.selectorBtnBuyAssinatura);

      $btnComprar.addClass("success").html("Adicionado!");

      setTimeout(function () {
        // _$form.find('.msg-response').slideUp(350);
        $btnComprar
          .removeClass("success")
          .html($btnComprar.data("text-available"));
      }, 3500);

      setTimeout(function () {
        window.location.href = urlAssinaturaCart;
      }, 150);
    } else if (_typeResult == "erro-adicionar") {
      if (typeof _result == "object") {
        var errorText = _result;
      } else {
        var errorText = JSON.parse(_result);
      }

      if (typeof _$boxResponse != "undefined" && _$boxResponse.length > 0) {
        console.info(errorText);

        _$boxResponse.addClass("error");
        _$boxResponse.removeClass("success");

        _$boxResponse.find("span").html(errorText.error);
        _$boxResponse.slideDown(350);
      }
    }
  },
  addItem: function (_$form, _$parent, addItemResult) {
    var _this = this;
    var $btnComprar = _$parent.find('[data-action="add-cart"]');
    var urlAdd = "/carrinho/adicionar";
    var urlUpdate = "/carrinho";
    var url = urlAdd;
    var form = _$form.serialize();
    var $boxResponse = _$parent.find(
      "[data-form-product] .msg-response:not(.resp-validate)"
    );

    console.info("addItem");
    console.info("addItem", _$form.serializeArray());

    if (!$btnComprar.hasClass("adding")) {
      $.ajax({
        url: url,
        type: "POST",
        dataType: "json",
        data: form,
        beforeSend: function () {
          $btnComprar.addClass("adding");
        },
      })
        .done(function (resp) {
          console.log("success");
          console.info(resp);

          if (typeof template_store.addItemResult == "function") {
            template_store.addItemResult(
              _$form,
              "produto-adicionado",
              resp,
              $boxResponse
            );
          } else {
            template_store.addItemResultDefault(
              _$form,
              "produto-adicionado",
              resp,
              $boxResponse
            );
          }
        })
        .fail(function (resp) {
          console.log("error");
          console.error(resp);
          console.error(resp.responseText);
          console.error(resp.responseText.error);

          if (typeof template_store.addItemResult == "function") {
            template_store.addItemResult(
              _$form,
              "erro-adicionar",
              resp,
              $boxResponse
            );
          } else {
            template_store.addItemResultDefault(
              _$form,
              "erro-adicionar",
              resp,
              $boxResponse
            );
          }
        })
        .always(function () {
          $btnComprar.removeClass("adding");
        });
    }
  },
  addItemAssinatura: function (_$form, _$parent, addItemResult) {
    var _this = this;
    var $btnComprar = _$parent.find(store.config.selectorBtnBuyAssinatura);
    var url = urlAssinaturaCartAdd;
    var form = _$form.serialize();
    var $boxResponse = _$parent.find(
      store.config.selectorFormProductAssinatura +
        " .msg-response:not(.resp-validate)"
    );
    var data = {};

    data.subscription_item = {
      quantity: _$form.find('[name="quantity"]').val(),
      sku: _$form.find('[name="sku"]').val(),
      extra: {
        vindi_plan_id: _$form.find('[name="extra[vindi_plan_id]"]').val(),
      },
    };

    console.info("addItemAssinatura");
    console.info("addItemAssinatura", data);
    console.info("addItemAssinatura", JSON.stringify(data));

    if (!$btnComprar.hasClass("adding")) {
      $.ajax({
        url: url,
        type: "POST",
        // dataType: 'json',
        contentType: "application/json",
        data: JSON.stringify(data),
        xhrFields: { withCredentials: true },
        beforeSend: function () {
          $btnComprar.addClass("adding");
        },
      })
        .done(function (resp) {
          console.log("success");
          console.info(resp);

          if (typeof template_store.addItemResult == "function") {
            template_store.addItemResult(
              _$form,
              "produto-adicionado",
              resp,
              $boxResponse
            );
          } else {
            template_store.addItemResultDefaultAssinatura(
              _$form,
              "produto-adicionado",
              resp,
              $boxResponse
            );
          }
        })
        .fail(function (xhr, status, error) {
          console.log("error");
          console.error(xhr);
          console.error(status);
          console.error(error);

          var resp = {
            error:
              "Houve um problema ao adicionar. Tente mais tarde ou entre em contato.",
          };

          if (typeof template_store.addItemResult == "function") {
            template_store.addItemResult(
              _$form,
              "erro-adicionar",
              resp,
              $boxResponse
            );
          } else {
            template_store.addItemResultDefaultAssinatura(
              _$form,
              "erro-adicionar",
              resp,
              $boxResponse
            );
          }
        })
        .always(function () {
          $btnComprar.removeClass("adding");
        });
    }
  },
  deleteItem: function (_itemId, _$item, removeItemResult) {
    var _this = this;

    if (!_$item.hasClass("removing")) {
      $.ajax({
        url: "/carrinho",
        type: "POST",
        dataType: "json",
        data: {
          _method: "delete",
          item_id: _itemId,
        },
        beforeSend: function () {
          _$item.addClass("removing");
        },
      })
        .done(function (_cart) {
          console.log("success");

          if ($body.width() > 768) {
            if (store.config.addToCartOpenCartpopup) {
              template_store.headerCart.loadCart(_cart);
              // template_store.headerCart.hide();
            }
          } else {
            if (store.config.addToCartOpenCartpopupMobile) {
              template_store.headerCart.loadCart(_cart);
              // template_store.headerCart.hide();
            }
          }

          if (typeof removeItemResult == "function") {
            removeItemResult(_$item, _cart);
          }
        })
        .fail(function (error) {
          console.log("erro ao remover", error.responseText);
        })
        .always(function () {
          _$item.removeClass("removing");
        });
    }
  },
  setMsgResponse: function (_msg, _type, _$parent) {
    /*
      O tipo pode conter um dos 3 valores: success, warning, error ou CLEAR.
      O type CLEAR limpa as mensagens e faz sumir a mensagem
    */

    // Verifica se não há mais de uma mensagem
    // caso tenha, gera um html para cada mensagem
    if (Array.isArray(_msg)) {
      var msgArr = _msg;
      _msg = "";
      for (var i = msgArr.length - 1; i >= 0; i--) {
        _msg += '<span class="msg error">' + msgArr[i] + "</span>";
      }
    }

    _$parent
      .find("[data-msg-retorno]")
      .removeClass("success")
      .removeClass("warning")
      .removeClass("error");

    _$parent.find("[data-msg-retorno] [data-msg]").empty();

    if (_type != "clear") {
      _$parent.find("[data-msg-retorno]").addClass(_type);
      _$parent.find("[data-msg-retorno] [data-msg]").html(_msg);
    }
  },
  updateCartCount: function (_itemsCount) {
    var _this = this;

    // $(_this.cartCount.selector).empty().text(_itemsCount);

    $(_this.config.cartCount.attr).data("cart-count-attr", _itemsCount);
    $(_this.config.cartCount.attr).attr("data-cart-count-attr", _itemsCount);

    $(_this.config.cartCount.attr).html(_itemsCount);
    $(_this.config.cartCount.text).html(_itemsCount);
    $(_this.config.cartCount.textLabel).html(
      _itemsCount > 1 ? "itens" : "item"
    );

    if (_itemsCount > 0) {
      $("[data-cart-body]").parent().addClass("active");
    } else {
      $("[data-cart-body]").parent().removeClass("active");
    }
  },
  getCartCount: function () {
    async function getCartItens() {
      let itens;

      try {
        itens = await $.ajax({
          url: "/carrinho/itens",
          type: "GET",
          dataType: "text",
        });

        return itens;
      } catch (error) {
        console.error(error);
      }
    }

    if ($(store.config.cartCount.selector).length > 0) {
      getCartItens().then((total) => {
        var itens = Number.isInteger(parseInt(total));
        if (itens) {
          $(store.config.cartCount.attr).attr("data-cart-count-attr", total);
          $(store.config.cartCount.selector).html(total);

          var $boxCart = $("[data-cart-body]");

          if ($boxCart.length > 0) {
            if (total > 0) {
              template_store.headerCart.loadCart();
            } else {
              $boxCart.html(`<p class="empty">R$ 000</p>`);
            }
          }
        }
      });
    }
  },
  getPriceProd: function () {
    var selector = store.config.priceProds.selector;
    var attr = store.config.priceProds.attr;

    if ($(selector).length > 0) {
      $(selector).each(function (index, value) {
        var $this = $(this);
        var prodId = $(this).data(attr);
        var url = "/produto/preco/" + prodId;

        if (prodId != "" && prodId != null) {
          $.ajax({
            url: url,
            type: "GET",
          })
            .done(function (resp) {
              console.log("success");
              // console.info(resp);
              $this.html(resp);
            })
            .fail(function (resp) {
              console.log("error");
              console.error(resp);
              console.error(resp.responseText);
              console.error(resp.responseText.error);
            })
            .always(function () {
            });
        }
      });
    }
  },
  submitForm: function (_$form) {
    _$form.find('[name="reply_to"]').val(_$form.find('[name="email"]').val());

    if (!_$form.hasClass("sending")) {
      $.ajax({
        url: "/webform",
        type: "POST",
        data: _$form.serialize(),
        beforeSend: function () {
          _$form.addClass("sending");
        },
      })
        .done(function () {
          // console.info('foi');
          // store.setMsgResponse('Mensagem enviada com sucesso!', 'success', _$form);
          _$form
            .find("[data-msg-retorno] [data-msg-success]")
            .addClass("visible");
          _$form
            .find("[data-msg-retorno] [data-msg-error]")
            .removeClass("visible");
          _$form.find("button[type=submit]").text("Enviado");

          setTimeout(function () {
            _$form.find("button[type=submit]").text("Enviar");
          }, 3500);
          _$form[0].reset();
        })
        .fail(function () {
          // console.info('foi, mas deu ruim');
          _$form
            .find("[data-msg-retorno] [data-msg-success]")
            .removeClass("visible");
          _$form
            .find("[data-msg-retorno] [data-msg-error]")
            .addClass("visible");
          _$form.find("button[type=submit]").text("Falha ao enviar");
          setTimeout(function () {
            _$form.find("button[type=submit]").text("Enviar");
          }, 3500);
          // store.setMsgResponse('Houve um problema ao enviar sua mensagem, tente novamente! Ou entre em contato conosco pelo telefone (21) 99644-6925 ', 'error', $form);
        })
        .always(function () {
          _$form.removeClass("sending");
        });
    }
  },
  login: {
    validateLogin: function (_$form) {
      var validated = true;
      var errorsTxt = [];

      if (_$form.find('[name="email"]').val() == "") {
        validated = false;
        errorsTxt.push("Informe seu email!");
      }

      if (_$form.find('[name="password"]').val() == "") {
        validated = false;
        errorsTxt.push("Informe a senha!");
      }

      return { validated: validated, errors: errorsTxt };
    },
    validateRegister: function (_$form) {
      var validated = true;
      var errorsTxt = [];

      if (_$form.find('[name="email"]').val() == "") {
        validated = false;
        errorsTxt.push("Informe seu email!");
      }

      if (_$form.find('[name="password"]').val() == "") {
        validated = false;
        errorsTxt.push("Informe uma senha!");
      }

      if (_$form.find('[name="password"]').val() != "") {
        var pass = _$form.find('[name="password"]').val();
        var confirmationPass = _$form
          .find('[name="password_confirmation"]')
          .val();

        if (pass != confirmationPass) {
          validated = false;
          errorsTxt.push("Senha e confirmação são diferentes!");
        }
      }

      return { validated: validated, errors: errorsTxt };
    },
    validateRecover: function (_$form) {
      var validated = true;
      var errorsTxt = [];

      if (_$form.find('[name="email"]').val() == "") {
        validated = false;
        errorsTxt.push("Informe seu email!");
      }

      return { validated: validated, errors: errorsTxt };
    },
    logar: function (_$form) {
      if (!_$form.hasClass("sending")) {
        $.ajax({
          url: "/entrar",
          type: "POST",
          dataType: "json",
          data: _$form.serialize(),
          beforeSend: function () {
            _$form.addClass("sending");
          },
        })
          .done(function (resp) {
            console.log("success", resp);

            if (resp.error) {
              store.setMsgResponse(resp.error, "error", _$form);
            }

            if (resp.client) {
              window.location.href = resp.redirect_to;
            }
          })
          .fail(function (resp) {
            console.error("error", error.responseText);
          })
          .always(function () {
            _$form.removeClass("sending");
          });
      }
    },
    recoverPassord: function (_$form) {
      if (!_$form.hasClass("sending")) {
        $.ajax({
          url: "/recuperar_senha",
          type: "POST",
          dataType: "json",
          data: _$form.serialize(),
          beforeSend: function () {
            _$form.addClass("sending");
          },
        })
          .done(function (resp) {
            console.log("success", resp);

            if (resp.error) {
              store.setMsgResponse(resp.error, "error", _$form);
            }

            if (resp.ok) {
              store.setMsgResponse(resp.ok, "success", _$form);
            }

            /*if (resp.client) {
            window.location.href = resp.redirect_to;
          }*/
          })
          .fail(function (resp) {
            console.error("error", error.responseText);
          })
          .always(function () {
            _$form.removeClass("sending");
          });
      }
    },
  },
};

window.template_store = {
  /* 
    Manda um ajax para o form de avise-me e também para um form da plataforma para o cliente receber um email
  */
  submitFormNotify: function (_$form) {
    var formData = _$form.serialize();

    if (!_$form.hasClass("sending")) {
      $.ajax({
        url: _$form.attr("action"),
        type: "post",
        dataType: "json",
        data: formData,
        beforeSend: function () {
          _$form.addClass("sending");
        },
      })
        .done(function (resp) {
          console.log("success");
          console.info(resp);

          var msgSuccess =
            "Você receberá um e-mail quando o produto estiver disponível";

          // Envia um email para o cliente saber que o usuário solicitou o avise-me
          $.ajax({
            url: "/webform",
            type: "POST",
            data: {
              key: _$form.find('[name="key"]').val(),
              reply_to: _$form.find('[name="email"]').val(),
              email: _$form.find('[name="email"]').val(),
              product_name: _$form.find('[name="nome"]').val(),
              referencia: _$form.find('[name="referencia"]').val(),
              sku: _$form.find('[name="sku"]').val(),
            },
          })
            .done(function (resp) {
              _$form
                .find("[data-msg-retorno] [data-msg-success]")
                .addClass("visible");
              _$form
                .find("[data-msg-retorno] [data-msg-error]")
                .removeClass("visible");

              _$form[0].reset();
            })
            .fail(function (error) {
              _$form
                .find("[data-msg-retorno] [data-msg-success]")
                .removeClass("visible");
              _$form
                .find("[data-msg-retorno] [data-msg-error]")
                .addClass("visible");
            })
            .always(function () {});
        })
        .fail(function (resp) {
          console.log("error");
          console.error(resp);
          console.error(resp.responseText);
          console.error(resp.responseText.error);

          var errorText = JSON.parse(resp.responseText);
          console.info(errorText);

          _$form
            .find("[data-msg-retorno] [data-msg-error]")
            .html(errorText.error);
          _$form
            .find("[data-msg-retorno] [data-msg-success]")
            .removeClass("visible");
          _$form
            .find("[data-msg-retorno] [data-msg-error]")
            .addClass("visible");
        })
        .always(function () {
          _$form.removeClass("sending");
        });
    }
  },
  /* 
    Função que executa o comportamento de quando o produto é adicionado no carrinho
  */
  addItemResult: function (_$form, _typeResult, _result, _$boxResponse) {
    var _this;

    if (_typeResult == "produto-adicionado") {
      var $btnComprar = _$form.find(store.config.selectorBtnBuy);

      $btnComprar.addClass("success").html(getText(language));

      setTimeout(function () {
        // _$form.find('.msg-response').slideUp(350);
        $btnComprar
          .removeClass("success")
          .html($btnComprar.data("text-available"));
      }, 3500);

      if ($body.width() > 768) {
        if (store.config.addToCartOpenCartpopup) {
          template_store.headerCart.loadCart(_result);
          template_store.headerCart.show();
        } else {
          setTimeout(function () {
            window.location.href = urlCart;
          }, 150);
        }
      } else {
        if (store.config.addToCartOpenCartpopupMobile) {
          template_store.headerCart.loadCart(_result);
          template_store.headerCart.show();
        } else {
          setTimeout(function () {
            window.location.href = urlCart;
          }, 150);
        }
      }
    } else if (_typeResult == "erro-adicionar") {
      var errorText = JSON.parse(_result.responseText);

      if (typeof _$boxResponse != "undefined" && _$boxResponse.length > 0) {
        $("html,body").animate(
          {
            scrollTop: _$boxResponse.offset().top,
          },
          "250"
        );

        console.info(errorText);

        _$boxResponse.addClass("error");
        _$boxResponse.removeClass("success");

        _$boxResponse.find("span").html(errorText.error);
        _$boxResponse.slideDown(350);

        setTimeout(function () {
          _$boxResponse.slideUp(350);
        }, 3500);
      }
    }
  },
  headerCart: {
    loadCart: function (_cart) {
      var _this = this;
      var $boxCart = $("[data-cart-body]");

      if (_cart) {
        console.log(_cart.items_count);
        store.updateCartCount(_cart.items_count);
      }

      vnda.loadCartPopup(function (html) {
        $boxCart.html(html);
        //console.log(html)
      });
    },
    show: function () {
      var $cartBody = $("[data-cart-body]");
      //var $cartHeader = $('.cart');

      $header.addClass("active");
      $cartBody.addClass("active");
      $('[data-action="close-all"]').addClass("active");

      setTimeout(function () {
        $header.removeClass("active");
        $cartBody.removeClass("active");
        $cartBody.parent().removeClass("active");
      }, 4000);
    },
    hide: function () {
      var $cartBody = $("[data-cart-body]");
      //var $cartHeader = $('.cart');

      $cartBody.removeClass("active");
      $cartBody.parent().removeClass("active");
    },
    toggle: function () {
      console.log("toggle");
      var $cartBody = $("[data-cart-body]");
      //var $cartHeader = $('.cart');

      $cartBody.parent().toggleClass("active");
      $('[data-action="close-all"]').toggleClass("active");
    },
    delete: function () {
      $(document).on(
        "click",
        '[data-action="delete-item-cart"]',
        function (event) {
          event.preventDefault();

          var $item = $(this).closest("[data-item-cart]");
          var itemId = $item.data("item-id");
          console.info("deletando item");

          store.deleteItem(itemId, $item);
        }
      );
    },
    updateQuantity: function () {
      $(document).on("click", '[data-cart-quantity="plus"]', function (e) {
        //console.log('adicionando mais um item')

        e.preventDefault();

        let quantityAvailable = parseFloat(
          e.target.closest("[data-item-cart]").dataset.itemStock
        );
        let sku = e.target.closest("[data-item-cart]").dataset.itemProductSku;
        let quantity = parseFloat(
          e.target.closest("[data-item-cart]").dataset.itemQuantity
        );

        if (quantityAvailable > 0) {
          $.ajax({
            url: "/carrinho/adicionar",
            type: "POST",
            dataType: "json",
            data: {
              quantity: quantity + 1,
              sku: sku,
            },
            xhrFields: { withCredentials: true },
          })
            .done(function (resp) {
              console.log("success");
              console.info(resp);
              template_store.headerCart.loadCart(resp);
            })
            .fail(function (xhr, status, error) {
              console.log("error");
              console.error(xhr);
              console.error(status);
              console.error(error);
            })
            .always(function () {
            });
        }
      });
    },
  },
  /*
    Debounce retorna uma função que enquanto continuar sendo chamada não é executada
    A função só será executada quando para de ser chamada por N milisegundos
    Útil para melhorar a performance de códigos que são executados muitas vezes por segundo, como o $(window).resize()

    Ex:
    
    $(window).resize(debounce(function() {
      // código a ser executado
    }, 500))
    
    No exemplo acima a função só será executada 500ms depois do último resize
    Abra o link abaixo e redimensione a janela branca e acompanhe o output do console
    Exemplo codepen: https://codepen.io/valkervieira/pen/oNgqyWY

    Um caso comum de uso é em lojas onde a seleção de um filtro na página de tag recarrega automáticamente a página
    Com o debounce o usuário pode escolher vários filtros rapidamente e a página só recarrega quando parar de escolher
  */
  debounce: function (func, wait, immediate = true) {
    var timeout;

    return function () {
      var context = this,
        args = arguments;

      var later = function () {
        timeout = null;
        if (!immediate) func.apply(context, args);
      };

      var callNow = immediate && !timeout;

      clearTimeout(timeout);

      timeout = setTimeout(later, wait);

      if (callNow) func.apply(context, args);
    };
  },

  /*
    Throttle diminui a frequencia que uma função é executada
    Enquanto no debounce a função só é executada quando para de ser chamada, no throttle ela
    continua sendo executada só que em um intervalo mínimo de N milisegundos (default = 250)

    Ex:

    $(window).resize(throttle() {
      // código a ser executado
    }, 500)

    No exemplo acima a função resize é chamada várias vezes por segundo mas só é executada 1 vez a cada 500ms
    Abra o link abaixo, redimensione a janela branca e acompanhe o console
    Exemplo codepen: https://codepen.io/valkervieira/pen/yLyKEPW

    Um caso comum de uso é checar se o scroll passou de um determinado ponto, para fixar um header ou alterar algum elemento do DOM
  */
  throttle: function (fn, threshhold, scope) {
    threshhold || (threshhold = 250);
    var last, deferTimer;
    return function () {
      var context = scope || this;

      var now = +new Date(),
        args = arguments;
      if (last && now < last + threshhold) {
        // hold on to it
        clearTimeout(deferTimer);
        deferTimer = setTimeout(function () {
          last = now;
          fn.apply(context, args);
        }, threshhold);
      } else {
        last = now;
        fn.apply(context, args);
      }
    };
  },
  changeHeaderHeight: function () {
    var topBar = 0;
    if (
      document.querySelector(".top-bar") &&
      document.querySelector(".top-bar").getBoundingClientRect().top == 0
    ) {
      topBar = document.querySelector(".top-bar").getBoundingClientRect()
        .height;
    }
    document.documentElement.style.setProperty(
      "--header-height",
      document.getElementById("header").offsetHeight + topBar + "px"
    );

    return document.getElementById("header").offsetHeight + topBar;
  },
  listProducts: function () {
    let listProducts = document.querySelectorAll('[data-slider="products"]');
    let productTemplate = document.querySelector('[data-page="product"]');
    let goOutTemplate = document.querySelector("body.go-out");

    if (listProducts) {
      listProducts.forEach(function (slider, index) {
        var sliderProducts = new Swiper(slider, {
          slidesPerView: productTemplate || goOutTemplate ? 2.5 : 3.5,
          loop: true,
          centeredSlides: false,
          spaceBetween: 0,
          simulateTouch: false,
          autoplay: {
            delay: 8000,
            reverseDirection: index % 2 == 0 ? false : true,
          },
          slidesPerGroup: 1,

          breakpoints: {
            767: {
              slidesPerView: 5.5,
              centeredSlides: true,
            },
            1440: {
              slidesPerView: 6.5,
            },
          },

          navigation: {
            nextEl: slider.querySelector(".button-next"),
            prevEl: slider.querySelector(".button-prev"),
          },

          on: {
            init: function () {
              //console.log(this, 'slideChange')
              setTimeout(() => lazyLoadInstance.update(), 900);
            },
          },
        });
      });
    }
  },
  listProductsBigger: function () {
    const listProductsBigger = document.querySelectorAll(
      '[data-slider="products-bigger"]'
    );

    if (listProductsBigger) {
      listProductsBigger.forEach(function (slider, index) {
        var sliderProducts = new Swiper(slider, {
          slidesPerView: 1.5,
          loop: true,
          centeredSlides: false,
          spaceBetween: 0,
          simulateTouch: false,
          autoplay: {
            delay: 3000,
            reverseDirection: index % 2 == 0 ? false : true,
          },
          slidesPerGroup: 1,

          navigation: {
            nextEl: slider.querySelector(".button-next"),
            prevEl: slider.querySelector(".button-prev"),
          },

          breakpoints: {
            767: {
              slidesPerView: 3.5,
              centeredSlides: true,
            },
          },

          on: {
            init: function () {
              //console.log(this)
              setTimeout(() => lazyLoadInstance.update(), 900);
            },
          },
        });
      });
    }
  },
  addToCartProducBlock: function () {
    var products = $(document).find('[data-add-cart="product-block"]');
    var variants = $(document).find("[data-sku]");
    var inputSku = $(document).find("input[name=sku]");
    var btnBuy = $(document).find('[type="submit"]');

    if (products) {
        if (variants) {
          $(document).on("click", "[data-add-cart='product-block'] [data-sku]", function (e) {
            e.preventDefault();
            var $formBuy = $(this).parents("form");
            var $inputFormBuy = $formBuy.find('input[name=sku]');
            var $submitBtnBuy = $formBuy.find('[type="submit"]')

            // console.log($inputFormBuy);
            // console.log($submitBtnBuy);
            var sku = $(this).data('sku');

            console.log("click na variante", $(this));
            // console.log(sku);

            $inputFormBuy.attr("value", sku);

            // console.log($inputFormBuy);

            // variants.removeClass("selected");
            $formBuy.find("[data-sku]").removeClass('selected');
            $(this).addClass("selected");

            $submitBtnBuy.attr("available", true);

            // btnBuy.setAttribute("available", true);
            // btnBuy.focus();
          });

        }

        if (btnBuy) {
          $(document).on("click", "[data-add-cart='product-block'] [type='submit']", function (e) {
          
            e.preventDefault();

            var $form = $(this).parent("form");
            var $parent = $(this).parent("form").parent();

            var respValidated = store.validateFormProduct($form);
            var $boxResponse = $parent.find(".resp-validate");

            if (respValidated.validated) {
              store.addItem($form, $parent);
            } else {
              console.info("não foi");
              store.setRespValidateProduct(respValidated, $form, $boxResponse);
            }
          });
        }
    }
  },
  mobileTouch: function () {
    if (screen.width < 767) {
      $(".product-block .sizes .size").on("touchstart", (el) => {
        $(el.currentTarget).click();
      });
    }
  },
  bar: {
    close: function () {
      let btnClose = document.querySelectorAll('[data-action="close-bar"]');

      btnClose.forEach((btn) => {
        btn.addEventListener("click", () => {
          btn.closest(".top-bar").remove();
        });
      });
    },
  },
  home: {
    setFullbanner: function () {
      const fullbanners = document.querySelectorAll("[data-fullbanner]");

      if (fullbanners) {
        fullbanners.forEach(function (slider, index) {
          var fullbanner = new Swiper(slider, {
            slidesPerView: 1,
            spaceBetween: 0,
            watchOverflow: true,
            autoplay: {
              delay: 5000,
            },

            navigation: {
              nextEl: slider.querySelector(".button-next"),
              prevEl: slider.querySelector(".button-prev"),
            },

            pagination: {
              el: slider.querySelector(".swiper-pagination"),
              type: "bullets",
            },
          });
        });
      }
    },
    setInfiniteScroll: function () {
      const body = document.getElementsByTagName("body")[0];
      const bodyHeight = document.body.scrollHeight / 2;
      const headerHeight = template_store.changeHeaderHeight();
      var remove = false;

      const language = document.querySelector('html').getAttribute('lang');

      const fetchHtml = async function () {
        body.classList.add("-fetching");
        console.log('fetch', `${document.location.href}?language=${language}`);

        const response = await fetch(`${document.location.href}?language=${language}`);
        const data = await response.text();
        const parser = new DOMParser();
        const doc = parser.parseFromString(data, "text/html");
        console.log('fetch language', doc.querySelector('html').getAttribute('lang'));
        const main = doc.querySelector('[data-action="change-content"]');

        //console.log(doc, main)

        document.getElementsByTagName("main")[0].appendChild(main);
        remove = true;
      };

      function removeFirstContent() {
        if (remove) {
          // console.log(document.querySelectorAll('[data-action="change-content"]')[1].getBoundingClientRect().top <= headerHeight, document.querySelectorAll('[data-action="change-content"]')[1].getBoundingClientRect().top, headerHeight)
          if (
            document
              .querySelectorAll('[data-action="change-content"]')[1]
              .getBoundingClientRect().top <= headerHeight
          ) {
            // console.log('remove de cima e refresh seções')
            body.classList.add("-changing");
            // console.log(headerHeight)
            document.querySelector('[data-action="change-content"]').remove();
            document.documentElement.scrollTop = 0;
            window.scrollTo(0,0);

            remove = false;
            setTimeout(() => {
              body.classList.remove("-changing");
              body.classList.remove("-fetching");
            }, 1000);
          }
        }
      }

      function observeContent() {
        // console.log(window.scrollY >= bodyHeight, window.scrollY, bodyHeight);
        if (
          window.scrollY >= bodyHeight &&
          !body.classList.contains("-fetching") &&
          !body.classList.contains("-changing")
        ) {
          fetchHtml().then(() => {
            lazyLoadInstance.update();
            template_store.home.setFullbanner();
            template_store.listProducts();
            template_store.listProductsBigger();
            template_store.addToCartProducBlock();
            store.getPriceProd();
          });
        }
      }

      window.addEventListener(
        "scroll",
        template_store.debounce(observeContent),
        900
      );

      window.addEventListener(
        "scroll",
        template_store.debounce(removeFirstContent),
        900
      );
    },
    init: function () {
      var _this = this;

      _this.setFullbanner();
      template_store.listProducts();
      template_store.listProductsBigger();
  //  template_store.home.setInfiniteScroll();
    },
  },
  product: {
    $sectionProduct: $("[data-section-product]"),
    $wrapperImages: $("[data-section-product]").find("[data-product-images]"),
    $sliderProduct: $("[data-section-product]").find(
      "[data-product-images] [data-main-slider]"
    ),
    $thumbsProduct: $("[data-section-product]").find("[data-slider-thumbs]"),
    sliderProduct: [],
    /* 
      Exibe as primeiras imagens do produto
      ** Importante para quando houver imagem por sku **
    */
    showFirstImages: function () {
      var _this = this;
      var variants = vnda.variants.all();
      var $imagesWithoutSkus = _this.$sliderProduct.find(".image-without-sku");
      var $thumbsWithoutSkus = _this.$thumbsProduct.find(".image-without-sku");

      if ($imagesWithoutSkus.length > 0) {
        /* 
          Todas as imagens sem skus são exibidas sempre
        */

        $imagesWithoutSkus.removeClass("inactive").addClass("active");

        $thumbsWithoutSkus.removeClass("inactive").addClass("active");
      } else {
        /* 
          Percorre todas as variantes
        */
        for (var i = 0; i < variants.length; i++) {
          if (variants[i].main) {
            console.info(variants[i]);

            // Procura a imagem que contém o sku e a exibe
            _this.$sliderProduct
              .find('[data-image][data-skus-image*="' + variants[i].sku + '"]')
              .addClass("active")
              .removeClass("inactive");

            _this.$thumbsProduct
              .find(
                '[data-image-thumb][data-skus-image*="' + variants[i].sku + '"]'
              )
              .addClass("active")
              .removeClass("inactive");
          }
        }
      }
    },
    setGallery: function () {
      var _this = this;

      if (_this.$thumbsProduct.length > 0) {
        var galleryThumbs = new Swiper(_this.$thumbsProduct, {
          slidesPerView: "auto",
          spaceBetween: 0,
          allowTouchMove: false,
          touchRatio: 0,
          freemode: true,
          watchOverflow: true,
        });

        var gallery = new Swiper(_this.$sliderProduct, {
          slidesPerView: 1,
          spaceBetween: 5,
          watchOverflow: true,
          observeParents: true,

          scrollbar: {
            el: _this.$sliderProduct.find(".swiper-scrollbar"),
            draggable: true,
          },

          navigation: {
            nextEl: _this.$sliderProduct.find(".button-next"),
            prevEl: _this.$sliderProduct.find(".button-prev"),
          },

          thumbs: {
            swiper: galleryThumbs,
          },

          on: {
            transitionEnd: function () {
              MagicZoom.refresh();
            }
          }
        });
      } else {
        var gallery = new Swiper(_this.$sliderProduct, {
          slidesPerView: 1,
          spaceBetween: 30,
          watchOverflow: true,
          observeParents: true,
          scrollbar: {
            el: _this.$sliderProduct.find(".swiper-scrollbar"),
            draggable: true,
          },
        });
      }

      this.sliderProduct.push(gallery);
    },
    submitNotify: function () {
      $(document).on("submit", "[data-form-notify]", function (event) {
        event.preventDefault();
        template_store.submitFormNotify($(this));
      });
    },
    setZoom: function () {
      var mzOptions = {
        lazyZoom: true,
        expand: "off",
        zoomOn: "click",
        zoomPosition: "inner",
        expandZoomMode: "off",
        hint: "off",
      };
    },
    init: function () {
      var _this = this;

      _this.showFirstImages();
      _this.setGallery();
      _this.submitNotify();
      _this.setZoom();

      template_store.listProducts();

      CheckProdCD.init();

      
      if (window.innerWidth < 768) {
        document
          .querySelector("[data-product-images]")
          .addEventListener("click", (e) => {
            if (
              e.target != document.querySelector('[data-action="close-zoom"]')
            ) {
              e.preventDefault();

              console.log(e);

              document
                .querySelector("[data-product-images]")
                .classList.add("-fullscreen");
              document.getElementsByTagName("body")[0].style.overflow =
                "hidden";

              // template_store.product.sliderProduct[0].update();
            }
          });
        document
          .querySelector('[data-action="close-zoom"]')
          .addEventListener("click", (e) => {
            e.preventDefault();

            console.log(e, document.querySelector("[data-product-images]"));

            document
              .querySelector("[data-product-images]")
              .classList.remove("-fullscreen");
            document.getElementsByTagName("body")[0].style.overflow = "";

            template_store.product.sliderProduct[0].update();
          });
      }
      

      $(document).on(
        "submit",
        store.config.selectorFormProduct,
        function (event) {
          event.preventDefault();

          var $form = $(this);
          var $parent = $form.closest(store.config.selectorWrapperProduct);

          var $btnComprar = $parent.find(store.config.selectorBtnBuy);

          var respValidated = store.validateFormProduct($form);
          var $boxResponse = $parent.find(".resp-validate");

          if (respValidated.validated) {
            store.addItem($form, $parent);
          } else {
            console.info("não foi", respValidated);
            store.setRespValidateProduct(respValidated, $form, $boxResponse);
          }
        }
      );
    },
  },
  tag: {
    init: function () {
      template_store.listProducts();
      template_store.home.setFullbanner();

      var btnOpenFilter = document.querySelector("[data-action=open-filters]");
      if (btnOpenFilter) {
        var btnClearFilters = document.querySelector(
          "[data-action=clear-filters]"
        );
        var height = btnOpenFilter.parentNode.querySelector(".filters-wrapper")
          .offsetHeight;
        var group = btnOpenFilter.parentNode.querySelector(".filters-group");
        if (group.classList.contains("active")) {
          group.style.height = height + "px";
        }

        btnOpenFilter.addEventListener("click", function (e) {
          e.preventDefault();
          group.classList.toggle("active");
          if (btnClearFilters) {
            btnClearFilters.classList.toggle("active");
          }
          if (group.classList.contains("active")) {
            group.style.height = height + "px";
          } else {
            group.style.height = "";
          }
        });
      }
    },
  },
  login: {
    init: function () {
      $("[data-content-login]").each(function (index, el) {
        // Animação
        $(el).on("click", "[data-forget-password]", function (event) {
          event.preventDefault();
          $(el).find("[data-form-login]").animate({ height: "toggle" }, 200);
          $(el).find("[data-form-recover]").animate({ height: "toggle" }, 200);
        });

        $(el).on("click", "[data-forget-password-back]", function (event) {
          event.preventDefault();
          $(el).find("[data-form-login]").animate({ height: "toggle" }, 200);
          $(el).find("[data-form-recover]").animate({ height: "toggle" }, 200);
        });

        $(el).on("submit", "[data-form-login]", function (event) {
          event.preventDefault();

          var $form = $(this);
          var respValidated = store.login.validateLogin($form);

          if (respValidated.validated) {
            store.login.logar($form);
          } else {
            store.setMsgResponse(respValidated.errors, "error", $(this));
          }
        });

        $(el).on("submit", "[data-form-register]", function (event) {
          event.preventDefault();

          var $form = $(this);
          var respValidated = store.login.validateRegister($form);

          if (respValidated.validated) {
            store.login.logar($form);
          } else {
            store.setMsgResponse(respValidated.errors, "error", $(this));
          }
        });

        $(el).on("submit", "[data-form-recover]", function (event) {
          event.preventDefault();

          var $form = $(this);
          var respValidated = store.login.validateRecover($form);

          if (respValidated.validated) {
            store.login.recoverPassord($form);
          } else {
            store.setMsgResponse(respValidated.errors, "error", $(this));
          }
        });

        $(el).on("click", '[data-action="open-register"]', function (event) {
          event.preventDefault();
          $(el).find("[data-form-login]").animate({ height: "toggle" }, 200);
          $(el).find("[data-form-register]").animate({ height: "toggle" }, 200);
        });

        $(el).on("click", '[data-action="back-login"]', function (event) {
          event.preventDefault();
          $(el).find("[data-form-login]").animate({ height: "toggle" }, 200);
          $(el).find("[data-form-register]").animate({ height: "toggle" }, 200);
        });
      });

      $(document).on("click", '[data-action="open-login"]', function (event) {
        event.preventDefault();
        $("[data-content-login]").animate({ height: "toggle" }, 200);
      });

      $(document).on(
        "click",
        '[data-action="open-newsletter"]',
        function (event) {
          event.preventDefault();
          $('[data-webform="newsletter"]')
            .parent()
            .animate({ height: "toggle" }, 200);
        }
      );
    },
  },
  init: function () {
    if (document.getElementById("header"))
      template_store.changeHeaderHeight();
    store.getPriceProd();
    store.getCartCount();
    template_store.addToCartProducBlock();
    template_store.headerCart.delete();
    template_store.headerCart.updateQuantity();
    template_store.bar.close();
    template_store.mobileTouch();

    if (document.getElementById("header"))
      window.addEventListener(
        "scroll",
        template_store.debounce(template_store.changeHeaderHeight)
      );

    $(window).on("scroll", function () {
      if ($(window).scrollTop() > 0) {
        $("#header").addClass("active");
      } else {
        $("#header").removeClass("active");
      }
    });

        // ===========================================================
    // i18n Collapsible
    //============================================================
    var i18nclick = true;
    $(".i18n-option").each(function () {
      if($(this).find('[data-selected]')) {
        $('.i18n-dropdown b').html($(this).find('[data-selected]').html());
      }
    });
    $(document).on('click','div.i18n-dropdown',function(e){
        e.preventDefault();
        if(i18nclick){
            $('.i18n-option').stop().slideDown(300);
            i18nclick = false;
        }else{
            $('.i18n-option').stop().slideUp(300);
            i18nclick = true;
        }
    });
    $(document).on('click','.i18n-option li',function(e){
      e.preventDefault();
      var option_value = $(this).html();
      var option_link = $(this).data('value');
      $('.i18n-dropdown b').html(option_value);
      $('.i18n-option').slideUp(300);
      i18nclick = true;
      location.replace(option_link)
    });

    var btnOpenMenu = document.querySelector('[data-action="open-menu"]');
    var btnOpenInfo = document.querySelectorAll('[data-action="open-info"]');

    var btnCloseMenu = document.querySelector('[data-action="close-menu"]');
    var btnCloseInfo = document.querySelector('[data-action="close-info"]');
    var btnCloseAll = document.querySelector('[data-action="close-all"]');

    var menuLateral = document.getElementById("menu-lateral");
    var infoLateral = document.getElementById("info-lateral");

    if (btnOpenMenu)
      btnOpenMenu.addEventListener("click", function () {
        var wrapperBtn = this.parentNode;
        infoLateral.classList.remove("visible");
        btnOpenInfo.forEach(function (btn) {
          btn.parentNode.classList.remove("active");
        });
        wrapperBtn.classList.add("active");
        menuLateral.classList.add("visible");
      });

    if (btnCloseMenu)
      btnCloseMenu.addEventListener("click", function () {
        var wrapperBtn = this.parentNode;
        wrapperBtn.classList.remove("active");
        menuLateral.classList.remove("visible");
      });

    if (btnOpenInfo.length)
      btnOpenInfo.forEach(function (btn) {
        btn.addEventListener("click", function () {
          var wrapperBtn = this.parentNode;
          btnCloseMenu.parentNode.classList.remove("active");
          menuLateral.classList.remove("visible");
          wrapperBtn.classList.toggle("active");
          infoLateral.classList.toggle("visible");
        });
      });

    if (btnCloseInfo)
      btnCloseInfo.addEventListener("click", function () {
        var wrapperBtn = this.parentNode;
        wrapperBtn.classList.remove("active");
        infoLateral.classList.remove("visible");
      });

    if (btnCloseAll)
      btnCloseAll.addEventListener("click", function (e) {
        e.preventDefault();
        btnCloseInfo.closest(".info").classList.remove("active");
        infoLateral.classList.remove("visible");
        btnCloseMenu.closest(".menu-options").classList.remove("active");
        menuLateral.classList.remove("visible");
        template_store.headerCart.hide();
        this.classList.remove("active");
        e.stopPropagation();
      });

    if (document.querySelector('[data-action="open-search"]'))
      document
        .querySelector('[data-action="open-search"]')
        .addEventListener("click", (e) => {
          e.target.parentNode.classList.toggle("active");
          document.getElementById("header").classList.toggle("active");
          if (e.target.parentNode.classList.contains("active")) {
            e.target.parentNode.querySelector("[name=q]").focus();
          }
        });

    if (document.querySelector('[data-action="toggle-cart"]'))
      document
        .querySelector('[data-action="toggle-cart"]')
        .addEventListener("click", (e) => {
          template_store.headerCart.toggle();
        });

    // ENVIO DE FORMULÁRIOS
    $("[data-webform]").on("submit", function (event) {
      event.preventDefault();
      var $form = $(this);

      var vnda = $(this).find('[name="vnda"]');

      if (vnda.length > 0) {
        if (vnda.val() != "") {
          console.info("ROBOT DETECTED");
          return false;
        }
      }

      store.submitForm($form);
    });

    template_store.login.init();
  },
};

$(function () {
  template_store.init();

  if (page == "home") {
    template_store.home.init();
  }
  console.log("page ", page);

  if (page == "product") {
    template_store.product.init();
  }

  if (page == "tag" || page == "search") {
    template_store.tag.init();
  }

  if (page == "login") {
    template_store.login.init();
  }

  if (page == "media/conteudo_post") {
    template_store.listProducts();
  }
});

console.log(
  "%cVnda - Tecnologia em Ecommerce",
  'color: #f88d5b; font-size: 15px; font-family: "Verdana", sans-serif; font-weight: bold;'
);
